<h1 class="harp-card-title">Account Recovery</h1>
<p>Select one of the options below to recover your account.</p>

<!-- Forgot User ID or Password -->
<p>
  <a
    class="forgot-info harp-destination-link"
    [routerLink]="['/login/forgot-account-info']"
    >Forgot user ID or password
    <strong class="icon ion-md-arrow-round-forward"></strong
  ></a>
  <br />
  <span class="harp-help-text"
    >Enter your email address to receive an email containing your user ID and
    instructions to reset your password.</span
  >
</p>

<hr />

<!-- Full Account Recovery -->
<p>
  <a
    class="full-account-recovery harp-destination-link"
    [routerLink]="['/login/full-recovery']"
    queryParamsHandling="merge"
    >Full Account Recovery
    <strong class="icon ion-md-arrow-round-forward"></strong
  ></a>
  <br />
  <span class="harp-help-text"
    >Enter your email address, first name, last name, and date of birth to
    receive an email containing instructions to recover your account.</span
  >
</p>

<hr />

<!-- PIV Card -->
<p>
  <a
    class="piv-card harp-destination-link"
    [routerLink]="['/login/piv-card-recovery']"
    queryParamsHandling="merge"
    >PIV Card <strong class="icon ion-md-arrow-round-forward"></strong
  ></a>
  <br />
  <span class="harp-help-text"
    >Having trouble signing in with PIV card? Learn more about how you can use
    your PIV card to log into HARP.</span
  >
</p>

<hr />

<!-- Account Deactivation -->
<p>
  <a
    class="account-deactivation harp-destination-link"
    [routerLink]="['/help']"
    fragment="login"
    queryParamsHandling="merge"
    >Account Deactivation
    <strong class="icon ion-md-arrow-round-forward"></strong
  ></a>
  <br />
  <span class="harp-help-text"
    >Did your account become deactivated? Learn more about what you can do in
    our FAQs.</span
  >
</p>

<hr />

<!-- Need more help -->
<p>
  <a
    class="need-help harp-destination-link"
    [routerLink]="['/login/contact']"
    queryParamsHandling="merge"
    >Need more help? <strong class="icon ion-md-arrow-round-forward"></strong
  ></a>
  <br />
  <span class="harp-help-text"
    >Please contact the help desk for additional assistance.</span
  >
</p>

<!-- Back to Login Page Button -->
<p>
  <a [routerLink]="['/login']" queryParamsHandling="merge"
    ><strong class="icon ion-md-arrow-round-back"></strong> Back to Login</a
  >
</p>
